import React from 'react';
import { Phone } from 'lucide-react';
import { useTelegram } from '../hooks/useTelegram';

const managers = [
  {
    id: 'kg',
    flag: '🇰🇬',
    name: 'Кыргызстан',
    role: 'Менеджер',
    phones: ['+996 701 500 002', '+996 707 610 077'],
  },
  {
    id: 'kz',
    flag: '🇰🇿',
    name: 'Казахстан',
    role: 'Менеджер · Для оформления аккаунта',
    phones: ['+7 705 665 18 48'],
  },
];

const Avatar = ({ flag, name }) => {
  const initials = (name || '?').slice(0, 1).toUpperCase();
  return (
    <div
      className="h-14 w-14 rounded-2xl border border-stroke bg-gradient-to-br from-white/10 to-white/5 flex items-center justify-center shadow-[0_18px_50px_rgba(59,130,246,0.10)]"
    >
      <span className="font-semibold text-text-primary text-3xl leading-none">{flag || initials}</span>
    </div>
  );
};

const ContactsPage = () => {
  const { tg } = useTelegram();

  const requestCall = (phone) => {
    const normalized = phone.replace(/\s/g, '');
    const doCall = () => {
      const href = `tel:${normalized}`;
      try {
        const a = document.createElement('a');
        a.href = href;
        a.rel = 'noreferrer';
        document.body.appendChild(a);
        a.click();
        a.remove();
        return;
      } catch (_) {
        // ignore
      }

      window.location.href = href;
    };

    doCall();
  };

  return (
    <div className="min-h-screen bg-bg text-text-primary pb-20">
      <div className="px-4 pt-6 max-w-5xl mx-auto">
        <h1 className="text-xl font-semibold tracking-tight">Контакты</h1>
        <p className="mt-2 text-sm text-text-secondary">Связь с менеджерами и складом.</p>

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {managers.map((m) => (
            <div key={m.id} className="rounded-2xl border border-stroke bg-surface backdrop-blur-md p-5">
              <div className="flex items-center gap-3">
                <Avatar flag={m.flag} name={m.name} />
                <div>
                  <div className="font-semibold text-text-primary">{m.name}</div>
                  <div className="text-xs text-text-muted">{m.role}</div>
                </div>
              </div>

              <div className="mt-4 space-y-2 text-sm">
                {m.phones.map((p) => (
                  <a
                    key={p}
                    href={`tel:${p.replace(/\s/g, '')}`}
                    onClick={(e) => {
                      requestCall(p);
                    }}
                    className="flex items-center gap-2 rounded-xl border border-stroke bg-white/3 px-3 py-2 hover:bg-white/5 transition"
                  >
                    <Phone size={16} className="text-neon-yellow" />
                    <span className="text-text-primary">{p}</span>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactsPage;

